import { Component, Input, OnInit, inject } from "@angular/core";
import { SystemSearchMetaRestService } from "@app/services/hal/system-search-meta-rest.service";
import { Store } from "@ngrx/store";
import { MatDialog } from "@angular/material/dialog";
import { UntypedFormBuilder } from "@angular/forms";
import { ActivatedRoute, Router, RouterLink } from "@angular/router";
import { ServiceErrorHandlerService } from "@app/view/shared/service-error-handler.service";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { BaseDataTablePageDirective } from "@app/view/shared/base-pages/base-data-table-page/base-data-table-page.directive";
import { ResourceGroupStore } from "@app/services/store/resource-group-store";
import { WorkGroup } from "@app/models/rest/work-group";
import { GroupStore } from "@app/services/store/group-store";
import { GroupMappingType } from "@app/models/enums/group-mapping-enum";
import { ResourceChooserDialogComponent } from "@app/view/shared/resource-chooser-dialog/resource-chooser-dialog.component";
import { ResourceGroup } from "@app/models/rest/resource-group";
import { MatToolbar } from "@angular/material/toolbar";
import { MatIconAnchor, MatButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { GridComponent } from "../../../shared/base-pages/base-data-table-page/grid.component";
import { MatPaginator } from "@angular/material/paginator";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-group-edit",
  templateUrl: "./group-edit.component.html",
  styleUrls: ["./group-edit.component.css"],
  imports: [
    MatToolbar,
    MatIconAnchor,
    RouterLink,
    MatIcon,
    MatButton,
    GridComponent,
    MatPaginator,
    TranslatePipe
  ]
})
export class GroupEditComponent
  extends BaseDataTablePageDirective<ResourceGroup>
  implements OnInit
{
  resourceGroupStore: ResourceGroupStore;
  protected store: Store<any>;
  protected dialog: MatDialog;
  protected formBuilder: UntypedFormBuilder;
  protected router = inject(Router);
  serverErrorHandler: ServiceErrorHandlerService;
  protected ngxUiLoaderService: NgxUiLoaderService;
  protected workGroupStore = inject(GroupStore);
  private activeRoute = inject(ActivatedRoute);

  public workGroupId: number;
  public workGroup: WorkGroup;
  @Input()
  public columns: object[] = [
    {
      type: "action",
      text: "",
      width: 50,
      actions: [
        {
          cls: "fa fa-user-edit",
          tooltip: "Select Resource",
          onClick: ({ record }) => {
            console.log("editing record", record);
            const dialogRef = this.dialog.open(ResourceChooserDialogComponent);
            //   , {
            //   width: '350px',
            //   data: { mode: 'NEW' }
            // });

            dialogRef.afterClosed().subscribe((result) => {
              console.log("The dialog was closed", result);
              // this.ngOnInit();
              // console.log(result);
              record.set("resource", result.data);
            });
          }
        }
      ]
    },
    {
      width: 60,
      type: "template",
      field: "resource.name",
      text: "Resource",
      flex: 1,
      template: ({ record }) =>
        !!record && !!record.resource
          ? `<dl style="margin:0">
                <dt><img src="${record.resource.imageUrl}"
                  height="40" width="40" style="border-radius:100%;box-shadow:1px 0 5px #aaa" alt="resource image"/></dt>
                </dl>${record.resource.name}`
          : "Choose Resource",
      editor: false
    },
    {
      text: "Behaviour",
      field: "groupMappingType",
      flex: 1,
      renderer: ({ record }) =>
        record.groupMappingType.toLocaleLowerCase() === "restricted"
          ? "Restrict to Group"
          : "Free Assignment",
      editable: false,
      editor: {
        type: "dropdown",
        items: [
          { display: "Restrict to Group", value: "Restricted" },
          { display: "Free Assignment", value: "Open" }
        ],
        displayField: "display",
        valueField: "value"
      }
    }
  ];

  constructor() {
    const systemSearchMetaRestService = inject(SystemSearchMetaRestService);
    const resourceGroupStore = inject(ResourceGroupStore);
    const store = inject<Store<any>>(Store);
    const dialog = inject(MatDialog);
    const formBuilder = inject(UntypedFormBuilder);
    const serverErrorHandler = inject(ServiceErrorHandlerService);
    const ngxUiLoaderService = inject(NgxUiLoaderService);

    super(
      systemSearchMetaRestService,
      resourceGroupStore,
      store,
      dialog,
      "ResourceGroup",
      formBuilder,
      serverErrorHandler,
      ngxUiLoaderService
    );
    this.resourceGroupStore = resourceGroupStore;
    this.store = store;
    this.dialog = dialog;
    this.formBuilder = formBuilder;
    this.serverErrorHandler = serverErrorHandler;
    this.ngxUiLoaderService = ngxUiLoaderService;

    this.activeRoute.params.subscribe((value) => {
      this.workGroupId = value["id"];
      this.loadWorkGroup(this.workGroupId);
    });
  }

  public get pristine() {
    return (
      !this.gridStore.changes ||
      (this.gridStore.changes.added.length === 0 &&
        this.gridStore.changes.removed.length === 0 &&
        this.gridStore.changes.modified.length === 0)
    );
  }

  ngOnInit() {
    super.ngOnInit();
  }

  loadWorkGroup(workGroupId) {
    this.workGroupStore.loadSingle(workGroupId).then((value) => {
      console.log("loading work group");
      this.workGroup = value;
      this.gridStore.parentField = "workGroup.id";
      this.gridStore.parentId = this.workGroup.id;
      this.gridStore.parentResource = this.workGroup;
      this.gridStore.parentRel = "workGroup";
      this.gridStore.autoCommit = false;
      this.gridStore.load({}).then();
    });
  }

  addRow() {
    this.gridStore.insert(0, {
      resource: null,
      groupMappingType: GroupMappingType.RESTRICTED,
      workGroup: this.workGroup
    });
  }
}
